import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ControlService } from '../services/control.service';
import { Config } from '../../config/config';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { ApiService } from '../services/api.service';


declare var jquery: any;
declare var $: any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  appDeviceType;
  channel_ids;
  channelTitle;
  playlist_ids;
  playlistTitle;
  private resourceID;
  resourceTitle;
  homeBreadcrumbs = "";
  private subBreadcrumbs = "";
  private sub2Breadcrumbs = "";
  private detailpageBreadcums = "";
  componentTitle = "";
  private pageTitle;
  itemList = [];
  selectedItems = [];
  settings = {};
  private responseData: any = {};
  private tags = "";
  private count: number = 0;
  private isOpen: boolean = false;
  private result_url;
  verify_result_component;
  private homeTitleColor;
  headerLogo;
  isSearchIconEnabled: boolean = false;
  isCloseIconEnabled: boolean = true;
  isCategorySearchIconEnabled: boolean = false;
  isCategoryCloseIconEnabled: boolean = true;
  searchPlaceHolderTitle = "";
  playlistComponentUrl:string = "";
  resourceComponentUrl:string = "";


  constructor(
    private location: Location,
    public controlService: ControlService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService) {
    this.componentTitle = this.controlService.componentTitle;

  }
  ngOnInit() {

    //  setting Breadcrumbs values or constants
    if (this.controlService.appDeviceType !== undefined) {

      this.appDeviceType = this.controlService.appDeviceType;
    } else {

      this.appDeviceType = JSON.parse(localStorage.getItem(Config.COOKIE_APP_DEVICE_TYPE));
    }
    if (this.appDeviceType == 1) {

      this.homeBreadcrumbs = Config.BREADCRUMBS_ADY_ECOMM;
      if (this.componentTitle == "PlaylistsComponent") {

        this.searchPlaceHolderTitle = Config.SEARCH_PLACEHOLDER_ECOMM;
      } else {

        this.searchPlaceHolderTitle = Config.SEARCH_PLACEHOLDER_DEFAULT;
      }
    } else {

      this.homeBreadcrumbs = Config.BREADCRUMBS_ADY_DEFAULT;
      if (this.componentTitle == "PlaylistsComponent") {

        this.searchPlaceHolderTitle = Config.SEARCH_PLACEHOLDER_DEFAULT;
      } else {

        this.searchPlaceHolderTitle = Config.SEARCH_PLACEHOLDER_DEFAULT_SUB;
      }
    }
    console.log("app_device_type : " + this.appDeviceType);
    this.subBreadcrumbs = this.controlService.subBreadcrumbs;
    this.sub2Breadcrumbs = this.controlService.sub2Breadcrumbs;
    this.detailpageBreadcums = this.controlService.detailpageBreadcums;
    this.homeTitleColor = (this.controlService.getHeaderTitleColor() != "") ? this.controlService.getHeaderTitleColor() : "";
    this.headerLogo = localStorage.getItem(Config.COOKIE_HOME_PAGE_LOGO);


    if (this.controlService.resource_results_url !== undefined) {
      this.result_url = this.controlService.resource_results_url;
    }
    this.getBreadcrumbsDetails();
    this.setHeader();
    if (this.controlService.filters == undefined || null) {

      this.getTagData();
    } else {

      this.itemList = this.controlService.filters;
    }

    this.selectedItems = this.controlService.filters_selected_items;
    this.settings = {
      singleSelection: false,
      text: "Select Fields",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      searchPlaceholderText: 'Search Fields',
      enableSearchFilter: false,
      badgeShowLimit: 1,
      groupBy: "category",
      classes: "filter-override"
    };
    if (this.controlService.getHeaderBarColor() != "") {
      $('.top-container').css("background-color", this.controlService.getHeaderBarColor());
      $('.main-header').css("background-color", this.controlService.getHeaderBarColor());
      $('.sub-sub-breadcrumb').css("background-color", this.controlService.getHeaderBarColor());
      $('.c-btn').css("background-color", this.controlService.getHeaderBarColor());
    }

    //$(".c-btn").html('<img style="height:20px;width:20px;" src="./assets/image/filter_icon.png"> Filter');
    $(".c-btn").html('<div class="header_sort_icon style="width=20px;"><svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 191.85 51.48" height="18px"><defs><style>.cls-1{fill:none;}.cls-2{fill:#464646;}</style></defs><title>filter</title><rect class="cls-1" x="0.21" width="27" height="37.2" style="fill: none;"/><path class="cls-2" d="M41.67,20.73H44a1.53,1.53,0,1,0,0-3.06h-2.3a1.53,1.53,0,1,0,0,3.06Zm0,0" transform="translate(-4.7 -7.4)"/><path class="cls-2" d="M60.48,9.26a2.43,2.43,0,0,0-2.2-1.33H7.14A2.54,2.54,0,0,0,5,9.26a2.44,2.44,0,0,0,.25,2.56l21.49,27v17.6A2.38,2.38,0,0,0,28,58.58a2.52,2.52,0,0,0,1.15.3,2.37,2.37,0,0,0,1.4-.42l6.76-4.69a3.73,3.73,0,0,0,1.52-3v-12l21.43-27a2.44,2.44,0,0,0,.25-2.56ZM35.61,36.64a1.29,1.29,0,0,0-.24.73V49.72a1.32,1.32,0,0,1-.49,1l-4.76,2.69V37.37a1.11,1.11,0,0,0-.48-1L17.88,21.1H37.49a1.83,1.83,0,0,0,1.7-1.22c.3-1.85-1.54-2.21-2.21-2.21H15l-3.85-5.31H54.28Zm0,0" transform="translate(-4.7 -7.4)"/><path class="cls-2" d="M94.32,36.25H77V54.41H71.45V13.35H97.2v4.37H77V31.88H94.32Z" transform="translate(-4.7 -7.4)"/><path class="cls-2" d="M108.56,16.09H103V10.42h5.55Zm0,38.32H103V23.9h5.55Z" transform="translate(-4.7 -7.4)"/><path class="cls-2" d="M123.11,54.41h-5.55v-44h5.55Z" transform="translate(-4.7 -7.4)"/><path class="cls-2" d="M139.38,16.54V23.9h5.79V28h-5.79V46.54a4.18,4.18,0,0,0,.89,3,3.23,3.23,0,0,0,2.36.87,4.86,4.86,0,0,0,1.07-.13,8.64,8.64,0,0,0,1-.26l.76,3.8a4.86,4.86,0,0,1-1.84.83,9,9,0,0,1-2.39.33,7.21,7.21,0,0,1-5.39-2q-2-2.05-2-6.42V28H129V23.9h4.85V16.54Z" transform="translate(-4.7 -7.4)"/><path class="cls-2" d="M163.75,55q-6.57,0-10.25-4.2t-3.68-11.06V38.5a15.83,15.83,0,0,1,3.79-10.87,11.92,11.92,0,0,1,9.26-4.3q6.12,0,9.18,3.81t3.06,10.12V40.2H155.6l-.09.14a12.65,12.65,0,0,0,2,7.46,7.13,7.13,0,0,0,6.21,2.86,13.88,13.88,0,0,0,4.95-.81,11,11,0,0,0,3.65-2.21l2.17,3.61a13.37,13.37,0,0,1-4.31,2.66A17.09,17.09,0,0,1,163.75,55Zm-.88-27.3a6,6,0,0,0-4.8,2.25,10.55,10.55,0,0,0-2.33,5.73l.06.14h13.76v-.45a8.91,8.91,0,0,0-1.64-5.5A5.93,5.93,0,0,0,162.87,27.7Z" transform="translate(-4.7 -7.4)"/><path class="cls-2" d="M195.78,28.8l-2.85-.17a6.31,6.31,0,0,0-3.7,1.05,6.59,6.59,0,0,0-2.33,2.93v21.8h-5.56V23.9h5l.53,4.45a10.58,10.58,0,0,1,3.2-3.69,7.71,7.71,0,0,1,5.57-1.23q.57.11.93.21Z" transform="translate(-4.7 -7.4)"/></svg></div>');
    $(".c-btn").css('border', 'none');
    $(".c-btn").css({ 'box-shadow': 'none', "display": "inherit", "position": "none", "text-align": "right", "padding": "0px" });

    if (this.controlService.getHeaderTitleColor() != "") {
      $('.title_color').css("color", this.controlService.getHeaderTitleColor());
      $('.dropdown').css("color", this.controlService.getHeaderTitleColor());
      $('.c-btn').css("color", this.controlService.getHeaderTitleColor());
      $('.header_sort_icon polygon').css("fill", this.controlService.getHeaderTitleColor());
      $('.header_sort_icon path').css("fill", this.controlService.getHeaderTitleColor());
      $('.header_hamburger_icon rect').css("fill", this.controlService.getHeaderTitleColor());
      $('.header_search_icon path').css("fill", this.controlService.getHeaderTitleColor());


    }
    $(".arrow-up, .arrow-down").css({
      'right': '0',
      "margin-right": "15px",
    });
    this.breadcrumbsVisibility();
    this.categorySearchVisibility();
    //window.onscroll = function () { stickyHeader() };

    var header = document.getElementById("main-header");
    var sticky = header.offsetTop;

    function stickyHeader() {

      if (window.pageYOffset > 5) { //top-container
        document.getElementById("top-container").style.display = "none";
        header.classList.add("sticky");

      } else {
        document.getElementById("top-container").style.display = "block";
        header.classList.remove("sticky");

      }
    }

    this.updateSortUrls();
  }

  updateSortUrls(){

    var resourceUrl = "/category/" + this.channelTitle + "/" + this.channel_ids + "/" + this.playlistTitle + "/" + this.playlist_ids;
    this.resourceComponentUrl = escape(resourceUrl);
    var playlistUrl = "/category/" + this.channelTitle + "/" + this.channel_ids;
    this.playlistComponentUrl = escape(playlistUrl);
  }

  onItemSelect(item: any) {

    console.log("Filters", this.selectedItems);
  }
  OnItemDeSelect(item: any) {

    console.log("Filters", this.selectedItems);
  }
  onSelectAll(items: any) {
    console.log("Filters", items);
  }
  onDeSelectAll(items: any) {
    console.log("Filters", items);
  }
  onClose(items: any) {
    if (this.controlService.filter_open) {
      if (this.selectedItems != undefined) {
        this.controlService.filters_selected_items = this.selectedItems;

        for (let item of this.selectedItems) {
          this.count++;
          this.tags = this.tags + item.filter;
          if (this.count < this.selectedItems.length) {
            this.tags += ',';
          }
        }
      }
      let navigationExtras: NavigationExtras = {
        queryParams: {
          "channel_ids": this.controlService.channel_ids,
          "channelTitle": this.controlService.channelTitle,
          "playlist_ids": this.controlService.playlist_ids,
          "playlistTitle": this.controlService.playlistTitle,
          "filter_items": this.tags
        }
      };
      if (this.selectedItems != undefined) {

        this.router.navigateByUrl('refresh', { skipLocationChange: true }).then(() => {

          this.router.navigate(['resources'], navigationExtras);
        });
      }
    }
    this.controlService.filter_open = false;

  }
  onOpen(items: any) {
    $(".arrow-up, .arrow-down").css({
      'right': '0',
      "margin-right": "15px",
    });
    this.controlService.filter_open = true;

  }

  setHeader() {

    switch (this.componentTitle) {
      case "DashboardHomeComponent":
        this.pageTitle = Config.CATEGORIES_NAME;
        break;
      case "PlaylistsComponent":
        this.pageTitle = this.channelTitle;
        this.controlService.playlist_ids = "";
        this.controlService.playlistTitle = "";
        break;
      case "ResourceComponent":
        if ((this.activatedRoute.snapshot.url[0] !== undefined) && (this.activatedRoute.snapshot.url[0].path == "resources")) {
          this.pageTitle = "Results";
        } else {
          this.pageTitle = this.playlistTitle;
        }
        break;
      case "DetailsPageComponent":
        this.pageTitle = this.resourceTitle;
        document.getElementById("sort_filter_row").style.display = "none";
        break;

    }
  }
  breadcrumbsVisibility() {

    switch (this.componentTitle) {
      case "DashboardHomeComponent":
        if ((this.activatedRoute.snapshot.url[0] !== undefined) && (this.activatedRoute.snapshot.url[0].path == "resources")) {
          document.getElementById("breadcrumb-item1").style.display = "inline-block";
          document.getElementById("breadcrumb-item5").style.display = "inline-block";
          document.getElementById("breadcrumb-item5").style.cursor = "text";
          document.getElementById("breadcrumb-item5").style.color = this.controlService.getHeaderTitleColor();


        } else {
          document.getElementById("breadcrumb-item1").style.display = "inline-block";
          document.getElementById("breadcrumb-item1").style.cursor = "text";
          document.getElementById("breadcrumb-item1").style.color = "black";

        }
        break;
      case "PlaylistsComponent":
        if ((this.activatedRoute.snapshot.url[0].path !== undefined) && (this.activatedRoute.snapshot.url[0].path == "resources")) {
          document.getElementById("breadcrumb-item1").style.display = "inline-block";
          document.getElementById("breadcrumb-item2").style.display = "inline-block";
          document.getElementById("breadcrumb-item5").style.display = "inline-block";
          document.getElementById("breadcrumb-item5").style.cursor = "text";
          document.getElementById("breadcrumb-item5").style.color = this.controlService.getHeaderTitleColor();


        } else {
          document.getElementById("breadcrumb-item1").style.display = "inline-block";
          document.getElementById("breadcrumb-item2").style.display = "inline-block";
          document.getElementById("breadcrumb-item2").style.cursor = "text";
          document.getElementById("breadcrumb-item2").style.color = "black";

        }
        break;
      case "ResourceComponent":
        if ((this.activatedRoute.snapshot.url[0].path !== undefined) && (this.activatedRoute.snapshot.url[0].path == "resources")) {
          document.getElementById("breadcrumb-item1").style.display = "inline-block";
          if (this.channelTitle != undefined && this.channelTitle != "") {
            document.getElementById("breadcrumb-item2").style.display = "inline-block";
          }
          if (this.playlistTitle != undefined && this.playlistTitle != "") {
            document.getElementById("breadcrumb-item3").style.display = "inline-block";
          }
          document.getElementById("breadcrumb-item5").style.display = "inline-block";
          document.getElementById("breadcrumb-item5").style.cursor = "text";
          document.getElementById("breadcrumb-item5").style.color = this.controlService.getHeaderTitleColor();
        } else {
          document.getElementById("breadcrumb-item1").style.display = "inline-block";
          document.getElementById("breadcrumb-item2").style.display = "inline-block";
          document.getElementById("breadcrumb-item3").style.display = "inline-block";
          document.getElementById("breadcrumb-item3").style.cursor = "text";
          document.getElementById("breadcrumb-item3").style.color = "black";
        }
        break;
      case "DetailsPageComponent":

        this.verify_result_component = this.activatedRoute.snapshot.url[8].path;
        document.getElementById("breadcrumb-item1").style.display = "inline-block";
        if (this.channelTitle != undefined && this.channelTitle != "") {
          document.getElementById("breadcrumb-item2").style.display = "inline-block";
        }
        if (this.playlistTitle != undefined && this.playlistTitle != "") {
          document.getElementById("breadcrumb-item3").style.display = "inline-block";
        }
        if (this.activatedRoute.snapshot.url[8].path == "ResourceComponent") {
          document.getElementById("breadcrumb-item5").style.display = "inline-block";
        }
        document.getElementById("breadcrumb-item4").style.display = "inline-block";
        document.getElementById("breadcrumb-item4").style.cursor = "text";
        document.getElementById("breadcrumb-item4").style.color = "black";
    }
  }
  getBreadcrumbsDetails() {

    this.channel_ids = this.controlService.channel_ids;
    this.channelTitle = this.controlService.channelTitle;
    this.playlist_ids = this.controlService.playlist_ids;
    this.playlistTitle = this.controlService.playlistTitle;
    this.resourceID = this.controlService.resourceID;
    this.resourceTitle = this.controlService.resourceTitle;
    if (this.channel_ids == undefined) {
      this.activatedRoute.queryParams.subscribe(params => {
        this.channel_ids = params["channel_ids"];
        this.channelTitle = params["channelTitle"];
        this.playlist_ids = params["playlist_ids"];
        this.playlistTitle = params["playlistTitle"];
      });
    }
  }
  openNav() {

    document.getElementById("mySidenav").style.width = "250px";
  }
  closeNav() {

    document.getElementById("mySidenav").style.width = "0";
  }
  logout() {

    this.controlService.clearServiceValue();
    this.controlService.clearCookie();
  }
  check() {

    this.controlService.clearServiceValue();
  }
  showSortDropDown() {
    if (document.getElementById("sort_dropdown").style.display == "block") {
      document.getElementById("sort_dropdown").style.display = "none";
    } else {
      document.getElementById("sort_dropdown").style.display = "block"
    }
  }
  getTagData() {

    console.log("HeaderComponent::getTagData");

    const body = {
      api_token: Config.API_TOKEN,
      station: this.controlService.getCookieValue()
    };
    return this.apiService.callWazzupV2Service(Config.RESOURCES_URL, body)
      .subscribe(data => {
        this.responseData = data
        this.controlService.filters = this.responseData.filters;
        this.itemList = this.controlService.filters;
      }
        , err => {
          console.log(Config.CONNECTION_ERROR_MSG);
        })
  }

  toggleFilters() {

    $(".c-btn").trigger('click');
  }

  openSearch() {

    var submitIcon = $('.searchbox-icon');
    var inputBox = $('.searchbox-input');
    var searchBox = $('.searchbox');

    if (this.isOpen == false) {
      searchBox.addClass('searchbox-open');
      inputBox.focus();
      this.isOpen = true;
      this.isSearchIconEnabled = true;
      this.isCloseIconEnabled = false;
    } else {
      searchBox.removeClass('searchbox-open');
      inputBox.focusout();
      this.isOpen = false;
      this.isSearchIconEnabled = false;
      this.isCloseIconEnabled = true;
    }
  }

  openCategorySearch() {

    var submitIcon = $('.searchbox-icon');
    var inputBox = $('.searchbox-input');
    var searchBox = $('.searchboxcategory');

    if (this.isOpen == false) {
      searchBox.addClass('searchbox-open');
      inputBox.focus();
      this.isOpen = true;
      this.isCategorySearchIconEnabled = true;
      this.isCategoryCloseIconEnabled = false;
    } else {
      searchBox.removeClass('searchbox-open');
      inputBox.focusout();
      this.isOpen = false;
      this.isCategorySearchIconEnabled = false;
      this.isCategoryCloseIconEnabled = true;
    }
  }

  onSearchKeydown(event) {

    if (event.key === "Enter") {

      console.log("Searching...")
      var inputVal = $('.searchbox-input').val();
      var inputValLength = $.trim(inputVal).length;
      let navigationExtras: NavigationExtras = {
        queryParams: {
          "channel_ids": "0",
          "channelTitle": "",
          "playlist_ids": "0",
          "playlistTitle": "",
          "filter_items": this.tags,
          "search_key": inputVal
        }
      };
      if (inputValLength !== 0) {

        this.router.navigateByUrl('refresh', { skipLocationChange: true }).then(() => {
          this.router.navigate(['resources'], navigationExtras);
        });
      }
    }
  }

  onCategorySearchKeydown(event) {

    if (event.key === "Enter") {

      console.log("Searching...")
      var inputVal = $('.category-searchbox-input').val();
      var inputValLength = $.trim(inputVal).length;
      let navigationExtras: NavigationExtras = {
        queryParams: {
          "channel_ids": this.controlService.channel_ids,
          "channelTitle": this.controlService.channelTitle,
          "playlist_ids": this.controlService.playlist_ids,
          "playlistTitle": this.controlService.playlistTitle,
          "filter_items": this.tags,
          "search_key": inputVal
        }
      };
      if (inputValLength !== 0) {

        this.router.navigateByUrl('refresh', { skipLocationChange: true }).then(() => {
          this.router.navigate(['resources'], navigationExtras);
        });
      }
    }
  }

  categorySearchVisibility() {

    if (this.componentTitle == "ResourceComponent" || this.componentTitle == "DashboardHomeComponent") {

      if (this.controlService.channel_ids && this.controlService.channel_ids != "0") {

        this.isCategorySearchIconEnabled = false;
      } else {

        this.isCategorySearchIconEnabled = true;
        this.isCategoryCloseIconEnabled = true;
      }
    } else if (this.componentTitle == "DetailsPageComponent") {

      this.isCategorySearchIconEnabled = true;
      this.isCategoryCloseIconEnabled = true;
    } else {

      this.isCategorySearchIconEnabled = false;
    }
  }
}
